// 📁 src/store/useTodoStore.ts
import { create } from "zustand";
import { AppRecordJK, AppRecordStatusJK, StatusMsg } from "utils";
import { AppLog } from "services";

interface MarketPlacesState {
  todos: any[];
  appRecord: AppRecordJK;
  initializePage: () => Promise<void>;
  disposePage: () => Promise<void>;
  fetchTodos: () => Promise<void>;
}

const useMarketPlacesStore = create<MarketPlacesState>((set, get) => ({
  todos: [],
  appRecord: new AppRecordJK(),

  initializePage: async () => {
    try {
    } catch (error) {
      AppLog.show({
        message: `[initializePage]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      set({ appRecord: new AppRecordJK({ loadingStatus: AppRecordStatusJK.loaded }) });
    }
  },

  disposePage: async () => {
    try {
      set({ appRecord: new AppRecordJK() });
    } catch (error) {
      AppLog.show({
        message: `[disposePage]`,
        status: StatusMsg.error,
        error,
      });
    }
  },

  fetchTodos: async () => {
    try {
    } catch (error) {
      console.error("Error fetching todos:", error);
      set({
        appRecord: new AppRecordJK({
          loadingStatus: AppRecordStatusJK.noLoadMore,
        }),
      });
    }
  },
}));

export default useMarketPlacesStore;

